import * as React from "react";
const SvgNewFile = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.8334 2.5H8.16669C6.76656 2.5 6.06649 2.5 5.53171 2.77248C5.06131 3.01217 4.67885 3.39462 4.43917 3.86502C4.16669 4.3998 4.16669 5.09987 4.16669 6.5V13.5C4.16669 14.9001 4.16669 15.6002 4.43917 16.135C4.67885 16.6054 5.06131 16.9878 5.53171 17.2275C6.06649 17.5 6.76656 17.5 8.16669 17.5H11.8334C13.2335 17.5 13.9336 17.5 14.4683 17.2275C14.9387 16.9878 15.3212 16.6054 15.5609 16.135C15.8334 15.6002 15.8334 14.9001 15.8334 13.5V7.5M10.8334 2.5L15.8334 7.5M10.8334 2.5V4.83333C10.8334 5.76675 10.8334 6.23346 11.015 6.58998C11.1748 6.90359 11.4298 7.15856 11.7434 7.31834C12.0999 7.5 12.5666 7.5 13.5 7.5H15.8334",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgNewFile;
